export default {
  "t-engagement-management": "Управление Активностью",
  "t-engagement-overview": "Обзор Вовлеченности",
  "t-overview": "Обзор",
  "t-device-model": "Модель Устройства",
  "t-sn-range": "Диапазон SN",
  "t-start-number": "Начальный номер",
  "t-end-number": "Конечный номер",
  "t-complete-sn-range-required": "Введите полный диапазон поиска SN",
  "t-filter": "Фильтр",
  "t-activation-rate": "Уровень Активации",
  "t-online-rate": "Уровень Онлайн",
  "t-usage-rate": "Уровень Использования",
  "t-high-frequency-activity-rate": "Уровень Высокой Активности",
  "t-silent-devices": "Неактивные Устройства",
  "t-activated-devices-count": "{count} активировано",
  "t-devices-count": "{count} устройств",
  "t-device-unit": "устр.",
  "t-compared-with-last-week": "к прошлой неделе",
  "t-trend": "Тренд",
  "t-trend-analysis": "Анализ Тренда",
  "t-recent-7-days": "Последние 7 дней",
  "t-recent-30-days": "Последние 30 дней",
  "t-recent-7-days-metrics-trend": "Тренд метрик за последние 7 дней",
  "t-recent-30-days-metrics-trend": "Тренд метрик за последние 30 дней",
  "t-total-uptime": "Общее Время Онлайн",
  "t-total-uptime-list": "Список Общего Времени Онлайн Устройств",
  "t-total-uptime-list-desc": "Статистика общей длительности подключения каждого устройства к TMS и активности по нескольким сигналам",
  "t-heartbeat-statistics": "Статистика Heartbeat",
  "t-heartbeat": "Статистика Heartbeat",
  "t-heartbeat-statistics-list": "Список Статистики Активных Сигналов Устройств",
  "t-heartbeat-statistics-list-desc": "Подробности многосигнальной активности по каждому устройству (чтение карты или трафик; достижение любого порога считается активностью)",
  "t-heartbeat-signal": "Активный Сигнал",
  "t-card-swipe-count": "Количество Чтений Карты",
  "t-print-count": "Количество Печатей",
  "t-print-distance": "Дистанция Печати",
  "t-business-traffic": "Бизнес-Трафик",
  "t-screen-on-duration": "Время Включенного Экрана",
  "t-active-time": "Время Активации",
  "t-active-time-list": "Список Времени Активации Устройств",
  "t-active-time-list-desc": "Запись момента, когда каждое устройство завершило активацию и впервые вышло в сеть",
  "t-days-from-now": "Прошло",
  "t-days-ago": "{count} дн. назад",
  "t-inactive-device-alert": "Оповещение о Тихом Устройстве",
  "t-inactive-device-alert-list": "Список Оповещений о Тихих Устройствах",
  "t-inactive-device-alert-list-desc": "Тихие устройства, у которых в прошлом месяце были активные сигналы, но в этом месяце нет активных сигналов и недостаточная длительность онлайн",
  "t-idle-device-alert": "Оповещение о Простаивающем Устройстве",
  "t-idle-device-alert-list": "Список Оповещений о Простаивающих Устройствах",
  "t-idle-device-alert-list-desc": "Список оповещений для устройств, которые онлайн, но не имеют активных сигналов за статистический период (многосигнальный OR L2: чтение карты/печать/трафик/включенный экран)",
  "t-idle-devices-total": "Всего Простаивающих Устройств",
  "t-idle-days": "Дней Простоя",
  "t-pending-activation": "Ожидает Активации",
  "t-pending-activation-list": "Список Ожидающих Активации",
  "t-pending-activation-list-desc": "Устройства, внесенные в систему TMS, но ни разу не активированные онлайн, отсортированные по дням с момента внесения (чем старше запись, тем больше внимания требуется)",
  "t-pending-activation-total": "Всего Устройств, Ожидающих Активации",
  "t-threshold-settings": "Настройки Порогов",
  "t-edit-threshold-settings": "Редактировать Настройки Порогов",
  "t-threshold-settings-list": "Список Настроек Порогов",
  "t-threshold-settings-list-desc": "Управление пороговыми параметрами для определения уровней активности в системе",
  "t-threshold-config-name": "Название Конфигурации",
  "t-threshold-type": "Тип Порога",
  "t-threshold-value": "Порог",
  "t-threshold-type-online-duration": "Длительность Онлайн",
  "t-threshold-type-silent-days": "Дни Без Активности",
  "t-threshold-type-idle-detection": "Обнаружение Простоя",
  "t-threshold-type-card-swipe-count": "Количество Чтений Карты",
  "t-threshold-type-unactivated-days": "Дни Без Активации",
  "t-threshold-type-screen-on-duration": "Время Экрана",
  "t-threshold-type-business-traffic": "Бизнес-Трафик",
  "t-online-duration-threshold": "Порог Длительности Онлайн",
  "t-silent-device-threshold": "Порог Неактивного Устройства",
  "t-idle-device-threshold": "Порог Простаивающего Устройства",
  "t-high-frequency-active-threshold": "Порог Высокой Активности",
  "t-unactivated-reminder-threshold": "Порог Напоминания об Активации",
  "t-screen-on-duration-threshold": "Порог Времени Экрана",
  "t-business-traffic-threshold": "Порог Бизнес-Трафика",
  "t-threshold-value-24h": "24 ч",
  "t-threshold-value-7-days": "7 дн.",
  "t-threshold-value-3-days": "3 дн.",
  "t-threshold-value-50-times-day": "50 раз/день",
  "t-threshold-value-30-days": "30 дн.",
  "t-threshold-value-2h": "2 ч",
  "t-threshold-value-10mb-day": "10 МБ/день",
  "t-online-duration-threshold-desc": "Устройства считаются активными, если непрерывная длительность онлайн превышает этот порог",
  "t-silent-device-threshold-desc": "Устройства считаются неактивными, если после этого числа дней не обнаружен активный сигнал",
  "t-idle-device-threshold-desc": "Устройства считаются простаивающими, если они онлайн без бизнес-активности дольше этого числа дней",
  "t-high-frequency-active-threshold-desc": "Устройства считаются высокоактивными, если дневное число чтений карты превышает этот порог",
  "t-unactivated-reminder-threshold-desc": "Напоминание срабатывает, если устройства остаются неактивированными после этого числа дней с момента внесения",
  "t-screen-on-duration-threshold-desc": "Устройства учитываются как активные, если дневное время включенного экрана превышает этот порог",
  "t-business-traffic-threshold-desc": "Устройства учитываются как активные, если дневной бизнес-трафик превышает этот порог",
  "t-pending-days": "Дней с Момента Внесения",
  "t-activation-analytics": "Аналитика Активации",
  "t-activation-analytics-list": "Аналитика Активации Партнеров",
  "t-activation-analytics-list-desc": "Обзор статуса активации устройств каждого партнера с поддержкой сортировки по уровню активации",
  "t-activation-analytics-total": "Всего в Аналитике Активации",
  "t-activation-rate-rank": "Уровень Активации",
  "t-partner-count": "Партнеры",
  "t-average-activation-rate": "Средний Уровень Активации",
  "t-highest-activation-rate": "Максимальный Уровень Активации",
  "t-lowest-activation-rate": "Минимальный Уровень Активации",
  "t-network-devices": "Онлайн-устройства",
  "t-activated": "Активировано",
  "t-unactivated": "Не Активировано",
  "t-entry-time": "Время Внесения",
  "t-inventory-estimation": "Оценка Наличия на Складе",
  "t-latest-heartbeat": "Последний Heartbeat",
  "t-suspected-in-inventory": "Вероятно на Складе",
  "t-long-term-not-powered-on": "Долго не включалось",
  "t-contact-partner-for-verification": "Связаться с партнером для проверки",
  "t-idle-duration": "Длительность Простоя",
  "t-hour-unit": "ч",
  "t-idle-over-72-hours": "Простой ≥72 Часов",
  "t-idle-24-72-hours": "Простой 24-72 Часа",
  "t-idle-under-24-hours": "Простой <24 Часов",
  "t-continuously-online-no-business": "Постоянно онлайн без операций",
  "t-follow-up-business-opening-status": "Уточнить статус открытия бизнеса",
  "t-possible-temporary-maintenance": "Возможно временное обслуживание",
  "t-current-online-status": "Текущий Онлайн-Статус",
  "t-warning-level": "Уровень Предупреждения",
  "t-warning-high": "Высокий",
  "t-warning-medium": "Средний",
  "t-warning-low": "Низкий",
  "t-contact-merchant": "Связаться с Мерчантом",
  "t-observe": "Наблюдать",
  "t-last-month-active-signal": "Активный Сигнал за Прошлый Месяц",
  "t-this-month-active-signal": "Активный Сигнал за Этот Месяц",
  "t-this-month-online-duration": "Онлайн-Длительность за Этот Месяц",
  "t-total-online": "Всего Онлайн",
  "t-last-active": "Время Последнего Выхода в Сеть",
  "t-total-devices-count": "Всего {count} устройств",
  "t-silent-devices-total": "Всего Неактивных Устройств",
  "t-risk-critical-days": "Критично (≥30 дн.)",
  "t-risk-medium-days": "Средний (14-29 дн.)",
  "t-risk-watch-days": "Наблюдение (7-13 дн.)",
  "t-suspected-fault-or-permanent-offline": "Возможная неисправность или постоянный офлайн",
  "t-merchant-status-follow-up-needed": "Требуется уточнить статус мерчанта",
  "t-continuous-monitoring": "Постоянный мониторинг",
  "t-silent-days": "Дней без активности",
  "t-day-unit": "дн.",
  "t-last-card-swipe-time": "Последнее Чтение Карты",
  "t-risk-level": "Уровень Риска",
  "t-risk-critical": "Критично",
  "t-risk-medium": "Средний",
  "t-risk-watch": "Наблюдение",
  "t-follow-up": "Проследить",
  "t-view-threshold-settings": "Просмотр настроек порогов",
  "t-close": "Закрыть",
  "t-fetch-failed": "Не удалось получить данные",
  "t-save-success": "Успешно сохранено",
  "t-save-failed": "Не удалось сохранить",
  "t-threshold-value-range": "Значение порога должно быть от 1 до 100",
}
